import React from "react";

import { Modal } from "@components/Page";
import { DRAWER_WIDTH2 } from "@components/Constants";
import { type OrganizationPublicKey } from "@api/types";

import OrganizationPublicKeyDetails from "./OrganizationPublicKeyDetails";

type Props = {
  publicKey?: OrganizationPublicKey;
  isOpen: boolean;
  onClose: () => void;
};

const OrganizationPublicKeyDetailsModal = ({
  publicKey,
  isOpen,
  onClose,
}: Props): JSX.Element => {
  const modalProps = {
    title: publicKey?.name,
    width: DRAWER_WIDTH2,
    isOpen,
    onClose,
  };

  const hasPublicKey = !!publicKey;

  return (
    <Modal {...modalProps}>
      {hasPublicKey
        ? <OrganizationPublicKeyDetails publicKey={publicKey} />
        : <></>}
    </Modal>
  );
};

export default OrganizationPublicKeyDetailsModal;
